import { FieldData } from "../CreateExportTypes";

export interface IExportState {
  get fields(): FieldData[];
  get exportType(): string;
  get emailHelperText(): string;
  get emailPlaceholderText(): string;
  get notificationText(): string;
  canSaveAndRun(selectedFields: FieldData[]): boolean;
}

// "Export for Analytics" specific logic
export class ExportForAnalytics implements IExportState {
  private _fields: FieldData[];

  get fields() {
    // All fields are available as-is. No filtering required.
    return this._fields;
  };

  get exportType() {
    return 'analytics';
  };

  get emailHelperText() {
    return 'eca.newExport.emailAnalyticHelper';
  };

  get emailPlaceholderText() {
    return 'eca.newExport.emailPlaceholder';
  };

  get notificationText() {
    return 'eca.newExport.emailNotification';
  };

  canSaveAndRun(selectedFields: FieldData[]): boolean {
    // "Save and Run" functionality is only available when one or more fields are selected
    return selectedFields.length > 0;
  };

  constructor(fieldData: FieldData[]) {
    this._fields = fieldData;
  };
}

// "Export for Review" specific logic
export class ExportForReview implements IExportState {
  private _fields: FieldData[];

  get fields() {
    // 1. Include all fields that are not "Standard Metadata"
    // 2. Include "Standard Metadata" fields only if "IsExportableForReview" is true
    const filteredData = this._fields.filter((item: FieldData) => 
      item.fieldCategoryLabel !== 'Standard Metadata' ||
      (item.fieldCategoryLabel === 'Standard Metadata' && item.isExportableForReview == true)
    );
    return filteredData;
  };

  get exportType() {
    return 'review';
  };

  get emailHelperText() {
    return 'eca.newExport.emailReviewHelper';
  };

  get emailPlaceholderText() {
    return 'eca.newExport.emailPlaceholderReview';
  };

  get notificationText() {
    return 'indexes.configureIndex.NotifyCompleted';
  };

  canSaveAndRun(_: FieldData[]): boolean {
    // "Save and Run" functionality is always available
    return true;
  };

  constructor(fieldData: FieldData[]) {
    this._fields = fieldData;
  };
}